var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconModalCrossBlack16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1E7D4FB4-2E0D-47E6-B610-49CAE8C5D361_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Rollivahetus",
    transform: "translate(-473.000000, -52.000000)",
    stroke: "black",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Modal-Cross_16px",
    transform: "translate(474.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L16,16",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,16 L16,0",
    id: "Path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalCrossBlack16Px);
export default __webpack_public_path__ + "static/media/Icon_Modal-Cross_Black_16px.b35f34c1d5537296eede8689ebea9f61.svg";
export { ForwardRef as ReactComponent };